import React from "react";
import {
    HomeOutlined, CloudSyncOutlined, TeamOutlined, BarChartOutlined, ProductOutlined,
    GlobalOutlined, AppstoreAddOutlined, FilePdfOutlined, ApartmentOutlined, ShopOutlined,
    SolutionOutlined, ShoppingCartOutlined, LineChartOutlined, UsergroupAddOutlined,
    SettingOutlined, AuditOutlined, FileDoneOutlined, LogoutOutlined
} from "@ant-design/icons";

export const LOGOUT_KEY = "__logout__"; // clave especial

// key: usa rutas/identificadores estables (ayuda con selected/open keys)
export const buildMenuConfig = (isAdmin) => {
    const base = [
        { key: "/inicio", path: "/inicio", icon: <HomeOutlined />, label: "Inicio", appName: "inicio" },

        {
            key: "participantes", label: "Llamadas",
            children: [
                { key: "/participante", path: "/participante", icon: <TeamOutlined />, label: "Participante", appName: "participantes" },
                { key: "/dashboardparticipante", path: "/dashboardparticipante", icon: <BarChartOutlined />, label: "Dashboard Participante", appName: "dashboardparticipante" },
                { key: "reporteRIT", label: (<><SettingOutlined style={{ marginRight: 6 }} />Reporte RIT</>), path: "/reporteRIT", appName: "reporteRIT" },
                //{ key: "/participantes", path: "/participantes", icon: <UsergroupAddOutlined />, label: "Línea base", appName: "participantes" },
                { key: "/es_proyectos", path: "/es_proyectos", icon: <ApartmentOutlined />, label: "Seleccionados", appName: "seleccionados", disabled: true },

            ],
        },

        {
            key: "entregas", label: "Entregas", appName: "entregas",
            children: [
                { key: "bodegas", label: (<><SettingOutlined style={{ marginRight: 6 }} />Bodegas</>), path: "/bodegas", appName: "bodegas" },
                { key: "actas", label: (<><FilePdfOutlined style={{ marginRight: 6 }} />Actas</>), path: "/actas", appName: "actas" },
                { key: "producto_2_impl2", label: (<><SettingOutlined style={{ marginRight: 6 }} />Proveedores</>), path: "/es_proyectos", appName: "bodegas", disabled: true },
                { key: "producto_3_impl3", label: (<><SettingOutlined style={{ marginRight: 6 }} />Etradas</>), path: "/es_proyectos", appName: "entradas", disabled: true },

            ],
        },

        {
            key: "financiero", label: "Financiero", appName: "financiero",
            children: [
                { key: "producto_1_impl4", label: (<><SettingOutlined style={{ marginRight: 6 }} />Compras</>), path: "/es_proyectos", appName: "compras", disabled: true },
                { key: "producto_1_impl5", label: (<><SettingOutlined style={{ marginRight: 6 }} />Entradas</>), path: "/es_proyectos", appName: "entradas", disabled: true },
                { key: "producto_1_impl6", label: (<><SettingOutlined style={{ marginRight: 6 }} />Salidas</>), path: "/es_proyectos", appName: "salidas", disabled: true },

            ],
        },

        {
            key: "mapas", label: "Mapas", appName: "mapas", path: "/mapas",
        },

        {
            key: "producto_3", label: "Seguimiento", appName: "producto_3",
            children: [
                { key: "/menu-curso-fortalecimiento", path: "/menu-curso-fortalecimiento", icon: <ProductOutlined />, label: "Fort. Capacidades", appName: "menu-curso-fortalecimiento" },
            ],
        },

        {
            key: "riesgos", label: "Riesgos", appName: "riesgos", path: "/riesgos",
        },

        {
            key: "info_general", label: "Informes", appName: "info_general",
            children: [
                {
                    key: "info_participacion", label: (<><BarChartOutlined style={{ marginRight: 8 }} />Informe Participación</>),
                    children: [

                        { key: "/novedad_participante", path: "/novedad_participante", icon: <FileDoneOutlined />, label: "Novedades", appName: "novedad_participante" },
                        { key: "/ecas_participante", path: "/ecas_participante", icon: <TeamOutlined />, label: "Ecas", appName: "ecas_participante" },
                        { key: "/visita_participante", path: "/visita_participante", icon: <TeamOutlined />, label: "Visitas", appName: "visita_participante" },
                    ],
                },
                { key: "/organizaciones", path: "/organizaciones", icon: <ShopOutlined />, label: "Organizacional", appName: "organizaciones" },
                { key: "/acuerdos-comerciales", path: "/acuerdos-comerciales", icon: <ShoppingCartOutlined />, label: "Comercial", appName: "acuerdos-comerciales" },
                { key: "/caracterizacion", path: "/caracterizacion", icon: <SolutionOutlined />, label: "Caracterización", appName: "caracterizacion" },
                { key: "/sistematizacionIppta", path: "/sistematizacionIppta", icon: <BarChartOutlined />, label: "IPPTA", appName: "sistematizacionIppta" },
                { key: "/encuestaEdah", path: "/encuestaEdah", icon: <LineChartOutlined />, label: "Encuesta EDAH", appName: "encuesta_EDAH" },
                { key: "/enfoqueGenero", path: "/enfoqueGenero", icon: <TeamOutlined />, label: "Enfoques Diferenciales", appName: "enfoqueGenero" },
                {
                    key: "plan_accion", label: (<><AuditOutlined style={{ marginRight: 8 }} />Plan de Acción</>),
                    children: [
                        { key: "/planes-accion?tipo=1", path: "/planes-accion?tipo=1", icon: <TeamOutlined />, label: "Ejecutados por FAO", appName: "planes-accion-fao" },
                        { key: "/planes-accion?tipo=2", path: "/planes-accion?tipo=2", icon: <TeamOutlined />, label: "Ejecutados por Organizaciones", appName: "planes-accion-fao" },
                    ],
                },
            ],
        },

        {
            key: "seguimiento", label: "Seguimiento", appName: "seguimiento",
            children: [
                { key: "/poa", path: "/poa", icon: <AppstoreAddOutlined />, label: "POA", appName: "poa" },
                { key: "/reportes", path: "/reportes", icon: <FilePdfOutlined />, label: "Informes", appName: "reportes" },
                { key: "/informe-actas", path: "/informe-actas", icon: <FilePdfOutlined />, label: "Informes Actas de Entrega", appName: "informe-actas" },
            ],
        },
    ];

    if (isAdmin) {
        base.push({
            key: "configuracion", label: "Configuración", appName: "app-admin",
            children: [
                { key: "/procesar_edah_admin", path: "/procesar_edah_admin", icon: <AppstoreAddOutlined />, label: "Procesar EDAH", appName: "procesar_edah_admin" },
                { key: "/comunix", path: "/comunix", icon: <GlobalOutlined />, label: "Configuración", appName: "comunix" },
            ],
        });
    }

    // Logout como acción especial
    base.push({
        key: LOGOUT_KEY,
        label: (<><LogoutOutlined /> Salir</>),
    });

    return base;
};
